<template>
  <a-config-provider :locale="zhCN">
    <div id="app" style="background: #f0f2f5">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
// import { API_bindAuthToken } from '@/api/userList.js'
// import { getParameterByName } from '@/utils/util.js'
const debounce = (fn, delay) => {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16)
    super(callback)
  }
}
export default {
  name: 'App',
  data() {
    return { zhCN }
  },
  created() {
    localStorage.setItem('lang', 'zh-CN')
    localStorage.setItem('app_language', 'zh-CN')
  },
  computed: {
    locale() {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && setDocumentTitle(`${i18nRender(title)} - ${domTitle}`)

      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    },
  },
}
</script>
<style lang="less">
/* .ant-menu-root {
  height: calc(100% - 64px) !important;
} */
.ant-layout.sidemenu {
  min-height: 100% !important;
}
.ant-pro-grid-content {
  padding-bottom: 10px;
}
.ant-card-head-title {
  font-weight: 800;
}
.ant-layout-footer {
  display: none;
}
.ant-modal div[aria-hidden='true'] {
  display: none !important;
}
/deep/.ant-tag {
  border: 0 !important;
  border-radius: 4px;
}
.ant-notification .ant-progress-text {
  width: 3.5em;
}
.ant-notification .ant-progress-show-info .ant-progress-outer {
  margin-right: calc(-3.5em - 8px);
  padding-right: calc(3.5em + 8px);
}
</style>
